import React from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';
import { useState } from 'react';

const ShareButton = ({ 
  title = "Check out Shot Clock Dating!", 
  text = "AI-powered speed dating with video calls and smart matching",
  url = window.location.href,
  className = ""
}) => {
  const { shareContent } = usePWA();
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareData = { title, text, url };
    const success = await shareContent(shareData);
    
    if (success && !navigator.share) {
      // If copied to clipboard, show feedback
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors ${className}`}
      title="Share Shot Clock Dating"
    >
      {copied ? (
        <>
          <Check size={16} className="text-green-400" />
          <span className="text-green-400">Copied!</span>
        </>
      ) : (
        <>
          {navigator.share ? (
            <Share2 size={16} />
          ) : (
            <Copy size={16} />
          )}
          <span>{navigator.share ? 'Share' : 'Copy Link'}</span>
        </>
      )}
    </button>
  );
};

export default ShareButton;